import * as DISTRICT_TYPES from './actionTypes';
import { DistrictActions, IDistrictState } from './types';

export const initialState: IDistrictState = {
  districtList: [],
  total: 0,
  loading: false,
  error: null
};

const districtReducer = (state = initialState, action = {} as DistrictActions): IDistrictState => {
  switch (action.type) {
    case DISTRICT_TYPES.FETCH_DISTRICT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DISTRICT_TYPES.FETCH_DISTRICT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        districtList: action.payload.districtList,
        total: action.payload.total,
        error: null
      };
    case DISTRICT_TYPES.FETCH_DISTRICT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case DISTRICT_TYPES.CLEAR_DISTRICT_LIST:
      return {
        ...state,
        districtList: [],
        total: 0,
        error: null
      };
    default:
      return state;
  }
};

export default districtReducer;
